<template>
    <div>
        <NewContact v-model="showNewContactDialog" />

        <NewEditBusiness v-model="showEditBusiness"
                         :business="selectedBusiness" />

        <v-row v-if="error" style="min-height: 50vh" align="center" justify="center">
            <div>
                <v-col class="text-center" cols="12" >
                    <v-icon color="error"
                            size="50">
                        mdi-alert
                    </v-icon>
                </v-col>

                <v-col cols="12" class="text-h6 text-center">
                    {{ $t('general.errorLoadingTheBusiness', { business: businessModule.s }) }}
                </v-col>

                <v-col class="text-center" cols="12" >
                    <v-btn color="kbRed" dark @click="$router.back()">
                        {{ $t('general.goBack') }}
                    </v-btn>
                </v-col>
            </div>
        </v-row>

        <v-row justify="center"
               style="min-height: 50vh"
               align="center"
               v-if="loadingBusiness">
            <v-progress-circular color="kbDarkBlue"
                                 indeterminate
                                 size="50">
            </v-progress-circular>
        </v-row>

        <v-row v-if="business">
            <v-col cols="12" class="mb-2 pb-0">
                <v-card color="kbLight">
                    <v-card-text>
                        <v-row class="pa-2"  align="center" >
                            <div>
                              <h3 id="text-h6"
                                  class="hidden-xs-only kbDarkBlueText--text mx-1">
                                <v-btn @click="$router.back()" icon>
                                  <v-icon color="kbDarkBlueText">
                                    arrow_back
                                  </v-icon>
                                </v-btn>

                                {{ business.name }}
                              </h3>

                              <span class="kbGray--text mt-2 pl-1 text-h6"
                                  v-show="business.code">
                                {{ $t('general.code') }}: {{ business.code }}</span>
                            </div>

                            <v-spacer/>

                            <v-btn @click="showNewContactDialog = true"
                                   class="mr-2"
                                   dark
                                   color="mainButtons">
                                <v-icon small class="hidden-sm-and-up">people</v-icon>
                                <span class="hidden-xs-only">
                                    {{ $t('general.addContact') }}
                                </span>
                            </v-btn>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="editBusiness()"
                                           color="mainButtons"
                                           icon
                                           v-on="on">
                                        <v-icon>
                                            edit
                                        </v-icon>
                                    </v-btn>
                                </template>

                                <span>{{ $t('general.editBusiness') }}</span>
                            </v-tooltip>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" class="hidden-sm-and-up">
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                business
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{business.name}}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('general.nameOfTheBusiness', { business: businessModule.s }) }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                email
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{business.email || $t('general.noEmail')}}</v-list-item-title>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                phone
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{business.phone || $t('general.noPhone')}}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('general.phone') }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                public
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{business.location || $t('general.noLocation')}}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('general.location') }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                my_location
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{business.address || $t('general.noAddress')}}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('general.address') }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider/>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <span class="text-h6 d-block mb-1 kbDarkBlueText--text">
                                  {{ $t('general.categories') }}
                                </span>
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon large color="kbDarkBlue">category</v-icon>
                                        </v-list-item-action>

                                        <span v-if="!business.categories || business.categories.length === 0">
                                            {{ $t('general.noCategories') }}
                                        </span>

                                        <v-chip class="mr-1"
                                                v-for="category in business.categories"
                                                :key="category">
                                            {{category}}
                                        </v-chip>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <span class="text-h6 d-block mb-1 kbDarkBlueText--text">
                                    {{ $t('general.segment') }}
                                </span>
                                <v-list :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                        two-line
                                        rounded
                                        class="pa-0">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlue"
                                                    large>
                                                mdi-segment
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>{{ business.segment || $t('general.noSegment') }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ $t('general.segment') }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>

                        <v-divider/>

                        <v-row class="mt-2">
                            <v-col cols="12">
                                <span class="text-h6 ml-4 kbDarkBlueText--text">{{ $t('general.extraData') }}</span>
                                <span class="d-block ml-4"
                                      v-if="!business.others || business.others.length === 0">
                                    {{ $t('general.noExtraDataFound') }}
                                </span>

                                <template v-for="(value, key) in business.others">
                                    <div class="ml-4 my-2"
                                         v-if="business.others && Object.keys(business.others).length > 0"
                                         :key="key">
                                        <span class="text-subtitle-1 d-block text-capitalize font-weight-medium">
                                            {{ key }}
                                        </span>
                                        <div class="extradata-chips-container">
                                            <template v-for="(data, index) in value">
                                                <v-chip class=" mr-2"
                                                        :key="index">
                                                    {{ data }}
                                                </v-chip>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12">
                <v-card color="kbWhite">
                    <v-card-text class="pa-0">
                        <ContactsList ref="contactsList"></ContactsList>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import NewContact from '@/pages/App/Businesses/dialogs/NewContact.vue'
import ContactsList from '@/pages/App/Businesses/ContactsList.vue'
import NewEditBusiness from '@/pages/App/Businesses/dialogs/NewEditBusiness.vue'
import notifications from '@/libs/notifications'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['businessModule'])
  },
  components: {
    NewContact,
    ContactsList,
    NewEditBusiness
  },
  created () {
    this.getBusiness()
  },
  data () {
    return {
      business: {},
      error: false,
      loadingBusiness: false,
      showNewContactDialog: false,
      showEditBusiness: false,
      selectedBusiness: ''
    }
  },
  methods: {
    editBusiness () {
      this.showEditBusiness = true
      this.selectedBusiness = this.$route.params.businessid
    },
    async getBusiness () {
      try {
        this.loadingBusiness = true
        this.business = await this.$store.dispatch('getBusiness', this.$route.params.businessid)
        if (this.business.others && Object.keys(this.business.others).length > 0) {
          for (const value in this.business.others) {
            if (!Array.isArray(this.business.others[value])) {
              this.business.others[value] = [this.business.others[value]]
            }
          }
        }
        this.loadingBusiness = false
      } catch (error) {
        this.loadingBusiness = false
        this.error = true
        notifications.error(error.message)
      }
    }
  }
}
</script>

<style>
    div.extradata-chips-container {
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
    }
</style>
